import { defineMessages } from 'react-intl'

const translations = defineMessages({
  headline: {
    defaultMessage: 'My Payment Methods',
    id: 'global.account.link.my_payment_methods'
  },
  noPaymentMethods: {
    defaultMessage: `You don't have any saved payment method, it will be added when place an order.`,
    id: 'msp.account.overview.no_payment_methods'
  }
})

export default translations
